import {
  OPEN_MODAL_POPUP,
  CLOSE_MODAL_POPUP,
  PopupInner,
} from "../types/siteTypes";

export const setModalOpen = (popupInner: PopupInner) => ({
  type: OPEN_MODAL_POPUP,
  popupInner,
});
export const closeModal = () => ({
  type: CLOSE_MODAL_POPUP,
});
